import { useVoucherCategories } from "@/shared/hooks/useVoucherCategories";
import { VoucherCategory } from "@/shared/types/voucherCategories.types";

export const useVoucherCategoryByEvent = (eventName: string): VoucherCategory | undefined => {
  const { data } = useVoucherCategories();

  if (!data?.voucher_categories) return undefined;

  return data.voucher_categories.find((category: VoucherCategory) => category.event === eventName);
};
